import {useContactForm} from './ContactFormContext.jsx';
import {useMemo} from 'react';
import {Alert, Link} from 'bonprix-design-system';
import Url from '@core/scripts/helper/url';

export function ConcernInfoText() {
    const {formValues, setFormValues} = useContactForm();

    const subjectConcernValue = `${formValues.subjectIndex}-${formValues.concernIndex}`;

    const infoText = useMemo(() => {
        switch (subjectConcernValue) {
            case '1-1':
                return 'Bitte schreiben Sie uns an welcher Stelle Sie nicht weiterkommen, damit wir Ihnen schnell helfen können.Bitte schreiben Sie uns an welcher Stelle Sie nicht weiterkommen, damit wir Ihnen schnell helfen können.';
            case '1-2':
                return (
                    <>
                        Wenn Du einzelne Artikel hinzufügen oder stornieren möchtest, gehe einfach in{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        und schaue nach, ob Du neben dem entsprechenden Artikel den Aktionsbutton „Artikel stornieren“
                        siehst. Solange Dir dieser Button angezeigt wird, ist die Bestellung stornierbar.
                        Ist dieser Button nicht mehr zu finden, ist eine Stornierung, auch durch unseren Kundenservice
                        nicht mehr möglich. In diesem Fall kannst Du die Annahme des Pakets verweigern oder die Artikel
                        einfach retournieren, die du nicht behalten möchtest.
                    </>
                );
            case '1-3':
                return (
                    <>
                        Wenn Du einzelne Artikel stornieren möchtest, gehe einfach in{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        und schaue nach, ob Du neben dem entsprechenden Artikel den Aktionsbutton „Artikel stornieren“ siehst.
                        Solange Dir dieser Button angezeigt wird, ist die Bestellung stornierbar. Ist dieser Button nicht
                        mehr zu finden, ist eine Stornierung, auch durch unseren Kundenservice nicht mehr möglich.
                        In diesem Fall kannst Du die Annahme des Pakets verweigern oder die Artikel einfach retournieren,
                        die du nicht behalten möchtest.
                    </>
                );
            case '1-4':
                return (
                    <>
                        Bitte nennen Sie uns die neue Lieferanschrift oder die vollständige Adresse des gewünschten Paketshops.
                        Für zukünftige Sendungen können Sie das ganz unkompliziert über{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                           Mein Konto
                         </Link>, im Menüpunkt „Mein Adressbuch“ regeln.
                    </>
                );
            case '1-5':
                return (
                    <>
                        Sie können Ihre Sendungen jetzt online verfolgen, wenn Sie sich für{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                          Mein Konto
                        </Link>{' '}
                        registriert haben.
                    </>
                );
            case '1-6':
                return 'Nennen Sie uns bitte das Datum der Bestellung, damit wir das besser prüfen können.';
            case '1-7':
                return 'Bitte schreiben Sie uns was nicht in Ordnung ist und wir helfen Ihnen gerne weiter. Bitte geben Sie die Rechnungsnummer und Artikelnummer an.';
            case '2-1':
                return (
                    <>
                        Wenn Sie sich für den Bereich{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                          Mein Konto
                        </Link>{' '}
                        registriert haben, können Sie Ihr Kundenkonto jederzeit online einsehen. Wenn Sie eine Rechnungskopie benötigen, finden Sie diese{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=/myaccount/invoices/')} target="_blank">
                          hier
                        </Link>.
                        Achtung: Wir verzichten bewusst auf den Versand einer Papier-Rechnung.
                    </>
                );
            case '2-2':
                return (
                    <>
                        Ihre Überweisung benötigt (je nach Bank) 2-7 Tage bis das Geld bei uns eingegangen ist.
                        Wenn Sie sich für den Bereich{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        registriert haben, können Sie Ihr Kundenkonto jederzeit online einsehen.
                    </>
                );
            case '2-3':
                return 'Bitte nennen Sie uns die gewünschte Zahlungsweise, damit wir besser prüfen können.';
            case '2-4':
                return 'Wir behalten uns vor, Zahlungsarten individuell anzubieten. Wenn Sie bestellen, werden Ihnen am Ende automatisch die Zahlungsarten angeboten, die möglich sind.';
            case '2-5':
                return (
                    <>
                        Ihre Überweisung benötigt (je nach Bank) 2-7 Tage bis das Geld bei uns eingegangen ist.
                        Wenn Sie sich für den Bereich{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        registriert haben, können Sie Ihr Kundenkonto jederzeit online einsehen.
                    </>
                );
            case '2-6':
                return (
                    <>
                        Wenn Sie sich für den Bereich{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        registriert haben, können Sie sofort Ihren aktuellen Kontostand online einsehen.
                    </>
                );
            case '2-7':
                return 'Bitte nennen Sie uns hierzu Ihre vollständige IBAN-Nummer sowie den Namen des Kontoinhabers.';
            case '3-1':
                return (
                    <>
                        Verpacken Sie bitte alles wieder, legen Sie den Lieferschein dazu.
                        Bitte kleben Sie den Retourenaufkleber auf das Paket und geben Sie es kostenlos in einer Postfiliale ab.
                        Wünschen Sie eine Ersatzbestellung, füllen Sie die Umtauschspalte auf der Rückseite
                        des Warenbegleitscheins aus. Die Bearbeitung und Gutschrift einer Rücksendung kann ca. 2 Wochen dauern.
                    </>
                );
            case '3-2':
                return (
                    <>
                        Die Bearbeitung und Gutschrift einer Rücksendung kann ca. 2 Wochen dauern.
                        Es kann sogar - wegen interner Abläufe - passieren, dass Rücksendungen aus einer Rechnung an
                        verschiedenen Tagen auf Ihrem Kundenkonto verbucht werden. Bitte warten Sie 2 Wochen.
                        Wenn Sie dann keine Gutschrift erhalten haben, brauchen wir diese Infos:<br />
                        • Kopie des Belegs<br />
                        • Rechnungsnummer -und Datum<br />
                        • Rücksendedatum<br />
                        • Artikelnummer
                    </>
                );
            case '4-1':
                return 'Eine Kundennummer erhalten Sie nach Ihrer ersten Bestellung. Sie finden sie auch auf Ihrer Bestellbestätigung. Alternativ teilen Sie uns bitte Ihre vollständige Anschrift mit, damit wir Ihre Kundennummer finden können.';
            case '4-2':
                return (
                    <>
                        Um ein neues Passwort zu erhalten, gehen Sie bitte wie folgt vor: Öffnen Sie bitte unsere{' '}
                        <Link href={Url.toAbsolute('/myAccountLogin.htm?')} target="_blank">
                            Anmelde-Seite
                        </Link>{' '}
                        und klicken Sie dort auf „Passwort vergessen“. Anschließend erhalten Sie von uns eine E-Mail mit einer Anleitung für die nächsten Schritte
                    </>
                );
            case '4-3':
                return (
                    <>
                        Die Anmeldung erfolgt durch Eingabe Ihrer Email-Adresse und Ihres persönlichen Passwortes.
                        Zur ersten Anmeldung müssen Sie den Bereich „Ich bin neu hier“ auf der rechten Seite wählen und
                        dort Ihre persönliche E-Mail-Adresse eingeben. Mit einem Klick auf „Weiter“ öffnet sich ein
                        neues Fenster, wo Sie Ihre persönlichen Angaben sowie Ihr persönliches Passwort eintragen können.
                    </>
                );
            case '4-4':
                return (
                    <>
                        Wenn Sie sich für den Bereich{' '}
                        <Link href={Url.toAbsolute('/myAccountLogin.htm?')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        registriert haben, können Sie direkt Ihre Daten ändern. Wenn wir das für Sie erledigen sollen, teilen Sie uns bitte Ihre alten und neuen Daten mit.
                    </>
                );
            case '4-5':
                return (
                    <>
                        Schade, dass wir Sie als Kundin verlieren. Haben Sie sich über uns geärgert?
                        Vielleicht schreiben Sie uns was schief gelaufen ist und geben Sie uns noch einmal
                        die Möglichkeit zu reagieren? Wir würden das dann gern in Ordnung bringen! Bitte nennen Sie uns
                        auf jeden Fall Ihre vollständige Anschrift, damit wir uns darum kümmern können.
                    </>
                );
            case '5-1':
                return 'Nennen Sie uns in Ihrer Nachricht bitte die Artikelnummer und die Größe, damit wir Ihnen schnell helfen können.';
            case '5-2':
                return 'Bitte schreiben Sie uns was nicht in Ordnung ist und wir helfen Ihnen gerne weiter. Bitte geben Sie die Rechnungsnummer und Artikelnummer an.';
            case '5-3':
                return 'Nennen Sie uns bitte die Artikelnummer und Größe. Gerne schauen wir nach wann der Artikel wieder verfügbar ist.';
            case '5-4':
                return 'Nennen Sie uns bitte die Artikelnummer, die Größe und den Preisunterschied.';
            case '5-5':
                return 'Nennen Sie uns bitte die Artikelnummer und die Größe.';
            case '5-6':
                return 'Nenne uns bitte die Artikelnummer.';
            case '6-1':
                return (
                    <>
                        Wurde Ihr Gutschein nicht akzeptiert oder haben Sie ihn bei der Bestellung vergessen?
                        Dann nennen Sie uns bitte Ihren Gutschein-Code oder den Newsletter-Betreff und die Höhe des Rabatts.
                        Wir prüfen gern, ob eine Gutschrift möglich ist.
                    </>
                );
            case '7-1':
                return (
                    <>
                        Auf unseren Serviceseiten können Sie sich für unseren{' '}
                        <Link href={Url.toAbsolute('/serviceleistung/newsletter/subscribe/')} target="_blank">
                            Newsletter
                        </Link>{' '}
                        anmelden.
                        Möchten Sie einen Katalog? Dann klicken Sie bitte{' '}
                        <Link href={Url.toAbsolute('/serviceleistung/bestellung/katalog-anfordern/')} target="_blank">
                          hier
                        </Link>.
                    </>
                );
            case '7-2':
                return (
                    <>
                        Auf unseren Serviceseiten können Sie sich für unseren{' '}
                        <Link href={Url.toAbsolute('/serviceleistung/newsletter/abmelden/')} target="_blank">
                            Newsletter
                        </Link>{' '}
                        abmelden. Außerdem finden Sie in jedem unserer Newsletter unten einen Abmeldelink. Wenn Sie keinen Katalog mehr möchten, teilen Sie uns bitte Ihre vollständige Anschrift mit.
                    </>
                );
        }
    });

    if (formValues.concernIndex === '0' || !infoText) {
        return null;
    }

    return (
        <div>
            <Alert isOpen severity="info" showCloseIcon={false}>
                {infoText}
            </Alert>
        </div>
    );
}
